/**
 * List of supported Segment Types
 * @param options object of options to build the list
 * @param options.includeEmpty boolean to include an empty name/value pair at the beginning
 * @param options.emptyData object of data to spread into the empty name/value pair if includeEmpty is true
 */
export function list(options = {}) {
  const list = [
    {
      label: 'Standard',
      value: 'standard',
    },
    {
      label: 'Added Value',
      value: 'added-value',
    },
  ];

  if (options.includeEmpty === true) {
    const emptyData = options.emptyData ?? {};

    list.unshift({
      label: '',
      value: '',
      ...emptyData,
    });
  }

  return list;
}

export default {
  list,
};
